module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('hospital-select', {
    attrs: {
      "continueSelect": true,
      "noSelectedOpen": false,
      "alwaysOpen": true
    },
    on: {
      "selected": _vm.go
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdb3c6ee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/hospitalSelect/hospitalSelect.vue
// module id = 872
// module chunks = 0